import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";
import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";

/**
 * Inline error banner displayed in the chat message scroll area when
 * an agent run fails. Provides retry and dismiss actions.
 *
 * NOT a snack-bar — rendered inline so it stays visible in context.
 */
@Component({
  selector: "lib-chat-error-banner",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButton, MatIcon],
  templateUrl: "./chat-error-banner.component.html",
  styleUrl: "./chat-error-banner.component.scss",
})
export class ChatErrorBannerComponent {
  /** Error message to display. Banner renders only when this is non-null. */
  readonly errorMessage = input<string | null>(null);

  /** Emitted when the user clicks "Retry". */
  readonly retry = output<void>();

  /** Emitted when the user clicks "Dismiss". */
  readonly dismiss = output<void>();
}
